<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<div class="text-field-config">
		<cbs-input
			class="w-full"
			type="number"
			name="text-length"
			v-validate="{
				min_value: 1
			}"
			v-model.number="localValue"
			:data-vv-as="$t('FieldConfig.TextLength')"
			:placeholder="`${$t('Actions.Input')} ${$t('FieldConfig.TextLength')}`"
		/>
		<span class="text-danger text-sm">{{ errors.first("text-length") }}</span>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	inject: ["parentValidator"],
	name: "TextFieldConfig",
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => prop.hasOwnProperty("validation")
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value.validation && this.value.validation.length;
			},
			set(val) {
				this.$emit("input", { ...this.value, validation: val ? { length: val } : null });
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>
